<h2 #h2 *ngIf="subheading" [innerText]="subheading" [class.text-animation]="article"></h2>
<h1 #h1 [innerText]="heading" [class.text-animation]="article"></h1>
<ng-content></ng-content>
